// src/components/providers/signal-provider/signal-provider.tsx
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation UnsaveItemFromTripProviderMutation($context: ContextInput!, $tripItem: TripItemInput!, $tripEntity: TripEntity!) {\n    trip(context: $context) {\n      unsaveItemFromTrip(tripItem: $tripItem, tripEntity: $tripEntity) {\n        ... on TripsView {\n          pageTitle\n        }\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import React from "react";
var SignalContext = React.createContext(void 0);
var SignalProvider = function (param) {
  var children = param.children;
  var _React_useState = _slicedToArray(React.useState([]), 2),
    subscribers = _React_useState[0],
    setSubscribers = _React_useState[1];
  var signalsRegistry = React.useMemo(function () {
    return [];
  }, []);
  var registerSignal = React.useCallback(function (signal) {
    if (!signal) {
      return {
        subscribe: null
      };
    }
    if (!signalsRegistry.find(function (signalInRegistry) {
      return Object.is(signalInRegistry, signal);
    })) {
      signalsRegistry.push(signal);
    }
    if (signal.reference) {
      var _subscribers_find;
      return {
        subscribe: (_subscribers_find = subscribers.find(function (s) {
          return s.result.reference === signal.reference;
        })) !== null && _subscribers_find !== void 0 ? _subscribers_find : null
      };
    }
    var _subscribers_find1;
    return {
      subscribe: (_subscribers_find1 = subscribers.find(function (s) {
        return s.result.type === signal.type;
      })) !== null && _subscribers_find1 !== void 0 ? _subscribers_find1 : null
    };
  }, [signalsRegistry, subscribers]);
  var onSignalEmit = React.useCallback(function (signal, callback) {
    var subscribe = registerSignal(signal).subscribe;
    if (subscribe && signal) {
      if (signal.reference && subscribe.result.reference && signal.reference === subscribe.result.reference) {
        callback(subscribe);
      }
      if (!signal.reference && signal.type === subscribe.result.type) {
        callback(subscribe);
      }
    }
  }, [registerSignal]);
  var emitSignals = React.useCallback(function (signals) {
    var typesInRegistry = signalsRegistry.map(function (signal) {
      return signal.type;
    });
    var _emitSignalInRegistry_signal_reference;
    var result = signals.filter(function (emitSignal) {
      return typesInRegistry.includes(emitSignal.signal.type);
    }).map(function (emitSignalInRegistry) {
      return {
        result: {
          type: emitSignalInRegistry.signal.type,
          reference: (_emitSignalInRegistry_signal_reference = emitSignalInRegistry.signal.reference) !== null && _emitSignalInRegistry_signal_reference !== void 0 ? _emitSignalInRegistry_signal_reference : void 0,
          values: emitSignalInRegistry.values
        }
      };
    });
    setSubscribers(result);
  }, [signalsRegistry]);
  var context = React.useMemo(function () {
    return {
      onSignalEmit: onSignalEmit,
      emitSignals: emitSignals
    };
  }, [onSignalEmit, emitSignals]);
  return /* @__PURE__ */React.createElement(SignalContext.Provider, {
    value: context
  }, children);
};
// src/components/providers/signal-provider/use-signals.ts
import React2 from "react";
function useSignals() {
  var signalContext = React2.useContext(SignalContext);
  if (signalContext === void 0) {
    throw new Error("No Trips SignalProvider found in React tree");
  }
  return signalContext;
}
// src/components/providers/signal-provider/use-emit-signals-handler.ts
import { useProvidedState } from "@shared-ui/provided-state-context";
var useEmitSignalsHandler = function (emitSignalValues) {
  var emitSignals = useSignals().emitSignals;
  var _useProvidedState = _slicedToArray(useProvidedState(), 1),
    state = _useProvidedState[0];
  return {
    emit: function () {
      var emitValues = emitSignalValues === null || emitSignalValues === void 0 ? void 0 : emitSignalValues.map(function (signal) {
        var values = signal.values.map(function (value) {
          switch (value.value.__typename) {
            case "TripsSignalFieldIdValue":
              {
                var fieldIdValue = value.value;
                var inputsValue = state.validatedInputs.inputFields.find(function (inputField) {
                  return inputField.inputId === fieldIdValue.id;
                });
                return {
                  __typename: value.__typename,
                  key: value.key,
                  value: inputsValue.inputValue
                };
              }
            case "TripsSignalFieldIdExistingValues":
              {
                var fieldIdExistingValues = value.value;
                var inputValues = fieldIdExistingValues.ids.map(function (id) {
                  return state.validatedInputs.inputFields.find(function (inputField) {
                    return inputField.inputId === id;
                  });
                }).map(function (inputField) {
                  return inputField.inputValue;
                });
                var _fieldIdExistingValues_prefixes;
                var combinedValues = _toConsumableArray((_fieldIdExistingValues_prefixes = fieldIdExistingValues.prefixes) !== null && _fieldIdExistingValues_prefixes !== void 0 ? _fieldIdExistingValues_prefixes : []).concat(_toConsumableArray(inputValues));
                return {
                  __typename: value.__typename,
                  key: value.key,
                  value: combinedValues
                };
              }
            default:
              return {
                __typename: value.__typename,
                key: value.key,
                value: null
              };
          }
        });
        return {
          __typename: signal.__typename,
          signal: signal.signal,
          values: values
        };
      });
      if (emitValues) {
        emitSignals(emitValues);
      }
    }
  };
};
// src/components/providers/trip-item-operations-provider/trip-item-operations-provider.tsx
import React4 from "react";
import { useMutation } from "@apollo/client";
// src/components/providers/trip-item-operations-provider/context/trip-item-operations-context.ts
import React3 from "react";
// src/components/providers/trip-item-operations-provider/get-default-operation-state.ts
function getDefaultTripItemOperationsState(defaultTripItemOperationKeys) {
  return defaultTripItemOperationKeys.reduce(function (accum, next) {
    return Object.assign(accum, _defineProperty({}, next, {
      status: "UNKNOWN"
    }));
  }, {});
}
// src/components/providers/trip-item-operations-provider/context/get-default-operation.ts
function getDefaultOperation(operationName) {
  return function () {
    return Promise.resolve({
      success: false,
      failureReason: "No TripItemOperationsProvider in tree found while calling ".concat(operationName),
      failure: {
        type: "NO_PROVIDER" /* NO_PROVIDER */
      }
    });
  };
}
// src/components/providers/trip-item-operations-provider/context/trip-item-operations-context.ts
var defaultTripItemOperationsContext = {
  unsaveItemFromTrip: getDefaultOperation("unsaveItemFromTrip")
};
var TripItemOperationsContext = React3.createContext(_objectSpreadProps(_objectSpread({}, defaultTripItemOperationsContext), {
  state: getDefaultTripItemOperationsState(Object.keys(defaultTripItemOperationsContext))
}));
// src/components/providers/trip-item-operations-provider/register-operation.ts
function registerOperation(params) {
  return function executeOperation(operation, updateState, variables) {
    updateState(function (prevState) {
      return _objectSpreadProps(_objectSpread({}, prevState), _defineProperty({}, params.operationName, {
        status: "IN_PROGRESS"
      }));
    });
    return operation({
      variables: variables
    }).then(function (response) {
      if (response.errors) {
        var error = {
          failureReason: "".concat(params.operationName, " failed with graphql error(s)"),
          failure: {
            type: "GRAPHQL" /* GRAPHQL */,
            errors: response.errors
          }
        };
        updateState(function (prevState) {
          return _objectSpreadProps(_objectSpread({}, prevState), _defineProperty({}, params.operationName, {
            status: "FAILURE",
            error: error
          }));
        });
        return _objectSpread({
          success: false
        }, error);
      }
      if (!response.data) {
        return Promise.reject(new Error("".concat(params.operationName, " returned null data")));
      }
      updateState(function (prevState) {
        return _objectSpreadProps(_objectSpread({}, prevState), _defineProperty({}, params.operationName, {
          status: "SUCCESS",
          result: response
        }));
      });
      return _objectSpread({
        success: true
      }, response);
    }).catch(function (error) {
      var failureReason = "unexpected error encountered while calling ".concat(params.operationName);
      var completeErrorMessage = "".concat(failureReason, ": ").concat(_instanceof(error, Error) ? error.message : error);
      var structuredError = {
        failureReason: failureReason,
        failure: {
          type: "UNKNOWN" /* UNKNOWN */,
          error: new Error(completeErrorMessage)
        }
      };
      updateState(function (prevState) {
        return _objectSpreadProps(_objectSpread({}, prevState), _defineProperty({}, params.operationName, {
          status: "FAILURE",
          error: structuredError
        }));
      });
      return _objectSpread({
        success: false
      }, structuredError);
    });
  };
}
// src/components/providers/trip-item-operations-provider/operations/unsave-item-from-trip/unsave-item-from-trip.ts
var unsaveItemFromTrip = registerOperation({
  operationName: "unsaveItemFromTrip"
});
// src/components/providers/trip-item-operations-provider/operations/unsave-item-from-trip/mutation/unsave-item-from-trip-mutation.ts
import { gql } from "@apollo/client";
var __UnsaveItemFromTripMutation = gql(_templateObject());
// src/components/providers/trip-item-operations-provider/trip-item-operations-provider.tsx
var TripItemOperationsProvider = function (param) {
  var children = param.children;
  var _useMutation = _slicedToArray(useMutation(__UnsaveItemFromTripMutation), 1),
    unsaveItemFromTripMutation = _useMutation[0];
  var _React4_useState = _slicedToArray(React4.useState(getDefaultTripItemOperationsState(Object.keys(defaultTripItemOperationsContext))), 2),
    operationState = _React4_useState[0],
    updateOperationState = _React4_useState[1];
  return /* @__PURE__ */React4.createElement(TripItemOperationsContext.Provider, {
    value: {
      unsaveItemFromTrip: function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return unsaveItemFromTrip.apply(void 0, [unsaveItemFromTripMutation, updateOperationState].concat(_toConsumableArray(args)));
      },
      state: operationState
    }
  }, children);
};
// src/components/providers/trip-item-operations-provider/hooks/use-trip-item-operations.ts
import React5 from "react";
function useTripItemOperations() {
  var _React5_useContext = React5.useContext(TripItemOperationsContext),
    unsaveItemFromTrip2 = _React5_useContext.unsaveItemFromTrip,
    rest = _objectWithoutProperties(_React5_useContext, ["unsaveItemFromTrip"]);
  return _objectSpread({
    unsaveItemFromTrip: React5.useCallback(unsaveItemFromTrip2, [])
  }, rest);
}
export { SignalProvider, TripItemOperationsProvider, useEmitSignalsHandler, useSignals, useTripItemOperations };